export const state = () => ({
  mode: 'GACHA',
  lastVisitedGacha: null,
})

export const mutations = {
  setMode(state, data) {
    state.mode = data
  },
  setLastVisitedGacha(state, data) {
    state.lastVisitedGacha = data
  },
}

export const actions = {
  setMode({ commit }, data) {
    commit('setMode', data)
  },
  setLastVisitedGacha({ commit }, data) {
    commit('setLastVisitedGacha', data)
  },
}

export const getters = {
  mode(state) {
    return state.mode
  },
  lastVisitedGacha(state) {
    return state.lastVisitedGacha
  },
}
